import React, { createContext, useContext, useMemo } from 'react';
import { FieldValues, useWatch } from 'react-hook-form';
import { ObjectSchema } from 'yup';

const SchemaValuesContext = createContext<FieldValues | undefined>(undefined);

/**
 * Provides cast form values so useIsRequired can resolve Yup `.when()` conditions
 * when deciding whether to show the required asterisk.
 * Must be used inside a react-hook-form FormProvider.
 */
export function SchemaValuesProvider({
  schema,
  children,
}: {
  schema: ObjectSchema<any>;
  children: React.ReactNode;
}) {
  const values = useWatch();
  const describeValues = useMemo(() => {
    try {
      return schema.cast(values ?? {}, { assert: false }) as FieldValues;
    } catch {
      return values;
    }
  }, [schema, values]);

  return (
    <SchemaValuesContext.Provider value={describeValues}>
      {children}
    </SchemaValuesContext.Provider>
  );
}

export function useSchemaDescribeValues() {
  return useContext(SchemaValuesContext);
}
